import React from "react";
import cx from "classnames";
//
import Icon from "./Icon";

export default function Button({
  title,
  small,
  tiny,
  full,
  mod,
  className,
  icon,
  disabled,
  href,
  ...rest
}) {
  mod = mod || [];
  mod = typeof mod === "string" ? [mod] : mod;

  if (small) mod.push("small");
  if (tiny) mod.push("tiny");
  if (full) mod.push("full");
  if (disabled && href) mod.push("disabled");

  className = cx(
    "o-btn",
    mod.map((mod) => `o-btn--${mod}`).join(" "),
    className
  );

  if (href) {
    if (disabled) {
      return (
        <span {...{ className }}>
          {icon ? <Icon name={icon} /> : null}
          {title}
        </span>
      );
    }

    return (
      <a target="_blank" {...{ ...rest, disabled, href, className }}>
        {icon ? <Icon name={icon} /> : null}
        {title}
      </a>
    );
  }

  return (
    <button type="button" {...{ ...rest, disabled, className }}>
      {icon ? <Icon name={icon} /> : null}
      {title}
    </button>
  );
}

export function ButtonBasic(props) {
  let mod;

  mod = props.mod || [];
  mod = typeof mod === "string" ? [mod] : mod;
  mod.push("basic");

  return <Button {...props} mod={mod} />;
}

export function ButtonIcon({ name, ...props }) {
  return <Button {...props} icon={name} mod="icon" />;
}

export function ButtonControl({ icon, ...props }) {
  return (
    <ButtonBasic {...props} mod="control" title={<Icon name={icon} large />} />
  );
}
